import { jsx as r, jsxs as t } from "react/jsx-runtime";
import "react";
import "dayjs";
import "react-i18next";
import "../../../contexts/global-context.js";
import "motion/react";
import "../../elements/button/button.js";
import "@radix-ui/react-dialog";
import { Heading as n } from "../../elements/heading/heading.js";
import "@radix-ui/react-accordion";
import "@vis.gl/react-google-maps";
import "haversine-distance";
import s from "../../elements/table/table.js";
const a = ({ isBlock: i, title: o, text: m, table: p, postTableText: e }) => /* @__PURE__ */ t("div", { children: [
  o && /* @__PURE__ */ r(n, { semanticType: i ? "h2" : "h3", visualType: i ? "h3" : "h4", children: o }),
  m && m,
  /* @__PURE__ */ r(s, { ...p }),
  e && /* @__PURE__ */ r("div", { className: "body-s", children: e })
] }), k = (i) => /* @__PURE__ */ r("div", { className: "space-mb-lg", children: /* @__PURE__ */ r(a, { ...i, isBlock: !1 }) });
export {
  k as TableBlockContent
};
